export default __webpack_public_path__ + "static/media/shelf-screenshot.67b237a4.png";